/**
 @author xiaoye
 @date 2020/4/22 4:01 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

// let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
let share = config.baseUrl.pro

//用户、资源分享、已被分享列表
let token01 = null;
export const GetResourceList = async (data) => {
    if (token01) {
        token01.cancel({
            status: 'cancel'
        });
    }
    token01 = axios.token();
    return axios.ajax({
        url: share.wb[2] + "/GetResourceList?" + qs.stringify(data),
        method: "get",
        token: token01.token,
    })
};

//建立分享
let token02 = null;
export const CreateShare = async (data) => {
    if (token02) {
        token02.cancel({
            status: 'cancel'
        });
    }
    token02 = axios.token();
    return axios.ajax({
        url: share.wb[2] + "/CreateShare",
        method: "post",
        data: data,
        token: token02.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//查看被分享的资源操作记录
let  token03 = null;
export const GetSharedLog = async (data) => {
    if ( token03) {
         token03.cancel({
            status: 'cancel'
        });
    }
     token03 = axios.token();
    return axios.ajax({
        url: share.wb[2] + "/GetSharedLog?" + qs.stringify(data),
        method: "get",
        token:  token03.token,
    })
};


//分享表的权限
let token04 = null;
export const GetDataSourceLists = async (data) => {
    if (token04) {
        token04.cancel({
            status: 'cancel'
        });
    }
    token04 = axios.token();
    return axios.ajax({
        url: share.wb[5] + "/GetDataSourceLists?" + qs.stringify(data),
        method: "get",
        token: token04.token,
    })
};